import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { recentNewsData, successStoriesData, featuredNewsData, tembeaGraduationData, communityDevelopmentData, beadsAlumniData, otherNewsData, newsletterArchivesData } from '../utils/BeadsData';

const formatForComparison = (str) => {
    return str
        // .replace(/[!,']/g, '')  // Remove certain special characters
        // .replace(/[$]/g, '$')   // Replace $ with 's'
        // .replace(/&/g, 'and')   // Replace & with 'and'
        // .replace(/[^\w\-]+/g, '-') // Replace all other non-alphanumeric chars with hyphens
        // .replace(/\-\-+/g, '-')   // Replace multiple hyphens with a single hyphen
        .replace(/&/g, 'and')       // Replace & with 'and'
        .replace(/[!']/g, '')       // Remove certain special characters
        .replace(/\s+/g, '-')       // Replace spaces with hyphens
        .replace(/[,!]/g, '')       // Remove commas and exclamation marks
        .toLowerCase(); // Convert to lowercase
};

const useNewsItem = () => {
    const { category, titlewithid } = useParams();

    const item = useMemo(() => {
        if (!titlewithid) {
            return null;
        }
        // Extracting title and id using lastIndexOf to find the last hyphen
        const lastHyphenIndex = titlewithid.lastIndexOf('-');
        const title = titlewithid.substring(0, lastHyphenIndex);
        const id = titlewithid.substring(lastHyphenIndex + 1);

        const formattedTitle = formatForComparison(decodeURIComponent(title));

        const allData = [...recentNewsData, ...successStoriesData, ...featuredNewsData, ...tembeaGraduationData, ...communityDevelopmentData, ...beadsAlumniData, ...otherNewsData, ...newsletterArchivesData];
        // return allData.find(item => 
        //     item.id === id && 
        //     item.category === category && 
        //     // item.title.toLowerCase() === title.toLowerCase()
        //     item.title.toLowerCase() === decodeURIComponent(title).toLowerCase()
        // );
        const foundItem = allData.find(item => {
            const itemTitle = item.title?.trim().replaceAll(' ', '-').toLowerCase()
            const itemCategory = item.category?.trim().replaceAll(' ', '-').toLowerCase()
            return item.id === id &&
                itemCategory === category &&
                formatForComparison(itemTitle) === formattedTitle
        });
        return foundItem;
    }, [category, titlewithid]);
    return item;
};

export default useNewsItem;

// const useNewsItem = () => {
//     const { category, titlewithid } = useParams()
//     if (!titlewithid) {
//         return null; // or a sensible default
//     }
//     const [title, id] = titlewithid.split('-')
//     return useMemo(() => {
//         const allData = [...recentNewsData, ...successStoriesData, ...featuredNewsData, ...tembeaGraduationData, ...communityDevelopmentData, ...beadsAlumniData, ...otherNewsData, newsletterArchivesData ];
//         return allData.find(item =>
//             item.id === id &&
//             item.category === category &&
//             item.title.toLowerCase() === title.toLowerCase()
//         );
//     }, [id, category, title]);
// };

// export default useNewsItem;